/**
 * Asynchronous `forEach`
 *
 * @typeParam T - The array type (infered)
 *
 * @param array Array to loop through
 * @param cb Asynchronous callback
 *
 * @example
 * ```ts
 * const array = [1, 2, 3];
 * await asyncForEach(array, async (item) => {
 * 	// some async code on item
 * });
 * ```
 */
export const asyncForEach = async <T extends Array<any> = any[]>(
	array: T,
	cb: (item: T[number], index: number, array: T) => Promise<any>,
): Promise<void> => {
	for (let index = 0; index < array.length; index++) {
		await cb(array[index], index, array);
	}
};
